const getUrlCulture = () => {
    return new URLSearchParams(window.location.search).get("culture");
};

const validUrlCulture = (languages) => {
    const urlCulture = getUrlCulture();

    if (!urlCulture || !Array.isArray(languages)) {
        return null;
    }

    const match = languages.find(
        (language) => language.culture.toLowerCase() === urlCulture.toLowerCase()
    );

    return match ? match.culture : null;
};

const getCulture = (state) => {
    const urlCulture = validUrlCulture(state.general.languages);
    if (urlCulture) {
        return urlCulture;
    }

    var culture = localStorage.getItem('culture') || null;
    return culture ? culture : state.general.culture;
};

const setCulture = (culture) => {
    localStorage.setItem('culture', culture);
};

const syncCultureToUrl = (culture) => {
    if (!culture) {
        return;
    }

    const url = new URL(window.location.href);
    if (url.searchParams.get("culture") === culture) {
        return;
    }

    url.searchParams.set("culture", culture);
    window.history.replaceState(window.history.state, "", url.toString());
};

export
{
    getCulture, setCulture, validUrlCulture, syncCultureToUrl
}
